<template>
  <div class="page home">
    <div class="page__content page__content--full">
      <div class="banners">
        <div class="banner">
          <template v-if="score">
          <p>Uw feedback score:</p>
          <router-link to="/feedback"><Stars :score="score.starspercentage"></Stars></router-link>
          </template>
          <Loader v-else></Loader>
        </div><!-- //TODO feedback score ophalen -->
        <div class="banner banner--warn" v-if="isMedicalWarn"><p><b>LET OP!</b> Uw medisch attest vervalt op
          {{ isMedicalWarn }}</p></div>
        <div class="banner" v-if="company===3 || company ===1">
          <p><b>Aangifte economische werkloosheid:</b> <span>U moet voor deze uitkeringsaanvraag enkel het formulier C3.2-WERKNEMER-CORONA indienen bij een
                    uitbetalingsinstelling. Als eerste datum werkloos vult u <b>13/03/2020</b> in.</span></p>
          <p>
            <a target="_blank" href="https://www.tijdelijkwerkloos.be/" class="button">ABVV</a>
            <a target="_blank"
               href="https://aclvb.slgnt.eu/optiext/optiextension.dll?ID=BZ4B%2BjRrjtxUmKXPF_BFjoFaXnYLDtUXpON_iNS3MuCUSZXRRAyFTfdpY9U19kLR5AtznimWFmmqhCHYDb"
               class="button">ACLVB</a>
            <a target="_blank" href="https://acvtijdelijkewerkloosheid.be/" class="button">ACV</a>
            <a target="_blank"
               href="https://www.hvw-capac.fgov.be/v2/mydossier/nl/mijn-hvw-dossier/tijdelijke-werkloosheid"
               class="button">HVW</a>
          </p>
        </div>
        <div class="banner" v-if="company===8">
          <p>Facturen onderaannemers staan terug online, bekijk ze op de
            <router-link to="/invoice" @click.native="visible=false"><b>"facturen"-pagina</b></router-link>
            .
          </p>
        </div>
      </div>
      <div class="page__controls">
        <router-link class="button page__controls__button" to="/trips" v-if="company!==1">Ritten</router-link>
        <button class="button page__controls__button" v-if="company!==1" @click="showBilloBordje">Billo bordje</button>
        <router-link class="button page__controls__button" to="/logos" v-if="company!==1">Logo's</router-link>
      </div>
    </div>
    <AssetModal v-if="activeAsset" :asset="activeAsset" @close-asset="activeAsset=null"></AssetModal>
  </div>
</template>

<script>

import {ObjectMixin} from "@/mixins/ObjectMixin";
import FeedbackService from "@/services/feedback";
import Loader from "@/components/Loader";
import Stars from "@/components/Stars";
import AssetModal from "@/components/AssetModal";
import AssetService from "@/services/asset";

export default {
  name: 'Home',
  components:{Loader,Stars, AssetModal},
  data() {
    return {
      user: this.$store.state.auth.user,
      score: 0,
      activeAsset: 0
    }
  },
  created() {
    this.fetchScore();
  },
  mixins: [ObjectMixin],
  computed: {
    company() {
      return parseInt(this.user.BEDRIJF) === 9 ? parseInt(this.user.BEDRIJFPORTAAL) : parseInt(this.user.BEDRIJF);
    },
    isMedicalWarn() {
      if (!this.user.DATMED || this.company === 8) {
        return false;
      }
      const medDate = new Date(this.user.DATMED);
      const now = new Date();
      now.setDate(now.getDate() + 60);
      if (medDate < now) {
        return ObjectMixin.formatDateString(medDate);
      }
      return false;
    }
  },

  methods: {
    fetchScore() {
      FeedbackService.getFeedbackScore(this.user.PERS_ID)
        .then(res => {
          if (res.status && res.data) {
            this.score = res.data;
          }
        })
    },
    showBilloBordje(){
      AssetService.getBilloBordje(this.user.PERS_ID)
      .then(res => {
        if(res.status && res.data){
          console.log(res.data);
          this.activeAsset = res.data;
        }
      })
    }
  }
}
</script>
